import { useMutation } from "@apollo/client";

import { GqlClientUserDeleteInput } from "~/__generated__";

import { ClientUserDeleteDocument } from "../mutations.generated";
import { ClientUserGetAllWithAccessToClientDocument } from "../queries.generated";

export default function useClientUserDelete() {
    const [mutate, { loading, error, data }] = useMutation(ClientUserDeleteDocument, {
        refetchQueries: [ClientUserGetAllWithAccessToClientDocument],
    });

    const deleteClientUser = (input: GqlClientUserDeleteInput) => mutate({ variables: { input } });

    return {
        deleteClientUser,
        loading,
        error,
        success: data?.clientUserDelete ?? false,
    };
}
